import * as def from '@/definitions'
import { ColorConstruct } from '@/utilityModels/colorConstruct'
import { ArrayHelper } from '@/helper/arrayHelper';
import { FontManager } from '@/model/fontManager/fontManager';

export class TableCellInfo
{
    // 背景色
    private _backgroundColor = new ColorConstruct(255, 255, 255);
    public get backgroundColor() { return this._backgroundColor; }
    public set backgroundColor(backgroundColor) { this._backgroundColor = backgroundColor; }

    // 幅 (レイヤーの幅100に対して正規化)
    private _cellWidthNormalized = 100;
    public get cellWidthNormalized() { return this._cellWidthNormalized; }
    public set cellWidthNormalized(cellWidthNormalized) { this._cellWidthNormalized = cellWidthNormalized; }

    // 高さ (レイヤーの高さ100に対して正規化)
    private _cellHeightNormalized  = 100;
    public get cellHeightNormalized () { return this._cellHeightNormalized ; }
    public set cellHeightNormalized (cellHeightNormalized ) { this._cellHeightNormalized  = cellHeightNormalized ; }

    // テキスト
    private _text = "";
    public get text() { return this._text; }
    public set text(text) { this._text = text; }

    // フォントId
    private _fontId = FontManager.DEFAULT_FONT_ID;
    public get fontId() { return this._fontId; }
    public set fontId(fontId) { this._fontId = fontId; }

    // テキスト色
    private _textColor = new ColorConstruct(0, 0, 0);
    public get textColor() { return this._textColor; }
    public set textColor(textColor) { this._textColor = textColor; }

    // フォントサイズ
    private _fontSize = 14;
    public get fontSize() { return this._fontSize; }
    public set fontSize(fontSize) { this._fontSize = fontSize; }

    // 自動(文字を枠に合わせたサイズにする)
    private _autoSize : boolean = true;
    public get autoSize() : boolean { return this._autoSize; }
    public set autoSize(autoSize : boolean) { this._autoSize = autoSize; }

    // 自動折り返し(ある程度で折り返す)
    private _autoNewLine : boolean = false;
    public get autoNewLine() : boolean { return this._autoNewLine; }
    public set autoNewLine(autoNewLine : boolean) { this._autoNewLine = autoNewLine; }

    // 字間
    private _letterSpacing = 0;
    public get letterSpacing() { return this._letterSpacing; }
    public set letterSpacing(letterSpacing) { this._letterSpacing = letterSpacing; }

    // 行間
    private _lineSpacing = 120;
    public get lineSpacing() { return this._lineSpacing; }
    public set lineSpacing(lineSpacing) { this._lineSpacing = lineSpacing; }

    // 影表示フラグ
    public isShadow : boolean = false;
    // 影色
    public shadowColor : ColorConstruct = new ColorConstruct(102, 102, 102);
    // 影距離(%)
    public shadowDistance : number = 10;
    // 影角度
    public shadowRotate : number = 45;
    // 影ぼかし(%)
    public shadowBlur : number = 50;
    // 影強さ(%)
    public shadowIntensity : number = 50;
    // 縁
    public isOutline : boolean = false;
    // 縁色
    public outlineColor : ColorConstruct = new ColorConstruct(255, 102, 0);
    // 縁太さ(%)
    public outlineThickness : number = 50;
    // 縁強さ(%)
    public outlineIntensity : number = 50;

    // 複製
    public clone()
    {
        var cloned = new TableCellInfo();
        this.cloneParameter(cloned);
        return cloned;
    }

    public cloneParameter(info : TableCellInfo)
    {
        info.backgroundColor = this.backgroundColor.clone();
        info.cellWidthNormalized = this.cellWidthNormalized;
        info.cellHeightNormalized = this.cellHeightNormalized;
        info.text = this.text;
        info.fontId = this.fontId;
        info.textColor = this.textColor.clone();
        info.fontSize = this.fontSize;
        info.autoSize = this.autoSize;
        info.autoNewLine = this.autoNewLine;
        info.letterSpacing = this.letterSpacing;
        info.lineSpacing = this.lineSpacing;
        info.isShadow = this.isShadow;
        info.shadowColor = this.shadowColor.clone();
        info.shadowDistance = this.shadowDistance;
        info.shadowRotate = this.shadowRotate;
        info.shadowBlur = this.shadowBlur;
        info.shadowIntensity = this.shadowIntensity;
        info.isOutline = this.isOutline;
        info.outlineColor = this.outlineColor.clone();
        info.outlineThickness = this.outlineThickness;
        info.outlineIntensity = this.outlineIntensity;
        return info;
    }

    // JSON
    public toJSON()
    {
        var jsonObj = {};
        jsonObj = this.saveParameterToJson(jsonObj);
        return jsonObj;
    }

    public saveParameterToJson(jsonObject)
    {
        jsonObject.backgroundColor = this.backgroundColor;
        jsonObject.cellWidthNormalized = this.cellWidthNormalized;
        jsonObject.cellHeightNormalized = this.cellHeightNormalized;
        jsonObject.text = this.text;
        jsonObject.fontId = this.fontId;
        jsonObject.textColor = this.textColor;
        jsonObject.fontSize = this.fontSize;
        jsonObject.autoSize = this.autoSize;
        jsonObject.autoNewLine = this.autoNewLine;
        jsonObject.letterSpacing = this.letterSpacing;
        jsonObject.lineSpacing = this.lineSpacing;
        jsonObject.isShadow = this.isShadow;
        jsonObject.shadowColor = this.shadowColor;
        jsonObject.shadowDistance = this.shadowDistance;
        jsonObject.shadowRotate = this.shadowRotate;
        jsonObject.shadowBlur = this.shadowBlur;
        jsonObject.shadowIntensity = this.shadowIntensity;
        jsonObject.isOutline = this.isOutline;
        jsonObject.outlineColor = this.outlineColor;
        jsonObject.outlineThickness = this.outlineThickness;
        jsonObject.outlineIntensity = this.outlineIntensity;
        return jsonObject;
    }

    public static createFromJsonData(jsonData : any) : TableCellInfo
    {
        var layer = new TableCellInfo();
        layer.loadParameterFromJson(jsonData);
        return layer;
    }

    public loadParameterFromJson(jsonData)
    {
        if(jsonData.backgroundColor != null) { this.backgroundColor = ColorConstruct.createFromJsonData(jsonData.backgroundColor); }
        if(jsonData.cellWidthNormalized != null) { this.cellWidthNormalized = jsonData.cellWidthNormalized; }
        if(jsonData.cellHeightNormalized != null) { this._cellHeightNormalized = jsonData.cellHeightNormalized; }
        if(jsonData.text != null) { this.text = jsonData.text; }
        if(jsonData.fontId != null) 
        {
            var fontId = jsonData.fontId;
            if(!FontManager.isWebFont(jsonData.fontId))
            {
                // ローカルフォントをコンバート
                fontId = FontManager.convertLocalToWebFontIfNeeded(jsonData.fontId);
                if(fontId != jsonData.fontId)
                {
                    // コンバートしたフォントを一時的に保存
                    FontManager.storeUnloadedFontIdIfNew(jsonData.fontId);
                }
            }
            this.fontId = fontId; 
        }
        if(jsonData.textColor != null) { this.textColor = ColorConstruct.createFromJsonData(jsonData.textColor); }
        if(jsonData.fontSize != null) { this.fontSize = jsonData.fontSize; }
        if(jsonData.autoSize != null) { this.autoSize = jsonData.autoSize; }
        if(jsonData.autoNewLine != null) { this.autoNewLine = jsonData.autoNewLine; }
        if(jsonData.letterSpacing != null) { this.letterSpacing = jsonData.letterSpacing; }
        if(jsonData.lineSpacing != null) { this.lineSpacing = jsonData.lineSpacing; }
        if(jsonData.isShadow) { this.isShadow = jsonData.isShadow; }
        if(jsonData.shadowColor) { this.shadowColor = ColorConstruct.createFromJsonData(jsonData.shadowColor); }
        if(jsonData.shadowDistance) { this.shadowDistance = jsonData.shadowDistance; }
        if(jsonData.shadowRotate) { this.shadowRotate = jsonData.shadowRotate;} 
        if(jsonData.shadowBlur) { this.shadowBlur = jsonData.shadowBlur; }
        if(jsonData.shadowIntensity) { this.shadowIntensity = jsonData.shadowIntensity; }
        if(jsonData.isOutline) { this.isOutline = jsonData.isOutline; }
        if(jsonData.outlineColor) { this.outlineColor = ColorConstruct.createFromJsonData(jsonData.outlineColor); }
        if(jsonData.outlineThickness) { this.outlineThickness = jsonData.outlineThickness; }
        if(jsonData.outlineIntensity) { this.outlineIntensity = jsonData.outlineIntensity; }
    }
}